import React from "react";
import { useState  } from "react";
import ss1 from "../assets/imgs/accessPageImgs/p1.png";
import ss2 from "../assets/imgs/accessPageImgs/p2.png";
import ss3 from "../assets/imgs/accessPageImgs/p3.png";
import SS4 from "../assets/imgs/accessPageImgs/p4.png";
import ss4 from "../assets/imgs/accessPageImgs/p5.png";
import ss5 from "../assets/imgs/accessPageImgs/p6.png";
import ss6 from "../assets/imgs/accessPageImgs/p7.png";
import ss7 from "../assets/imgs/accessPageImgs/p8.png";
import ss8 from "../assets/imgs/accessPageImgs/p9.png";
import ss10 from "../assets/imgs/accessPageImgs/p10.png";
import ss11 from "../assets/imgs/accessPageImgs/p11.png";
import ss13 from "../assets/imgs/accessPageImgs/p13.png";
import ss14 from "../assets/imgs/accessPageImgs/p14.png";
import ss15 from "../assets/imgs/accessPageImgs/p15.png";
import ss16 from "../assets/imgs/accessPageImgs/p16.png";
import ss17 from "../assets/imgs/accessPageImgs/p17.png";
import ss18 from "../assets/imgs/accessPageImgs/p18.png";
import ss19 from "../assets/imgs/accessPageImgs/p19.png";
import ss20 from "../assets/imgs/accessPageImgs/p20.png";
import download from "../assets/imgs/accessPageImgs/download.png";

import pss1 from "../assets/imgs/accessPageImgs/pss1.png";
import pss2 from "../assets/imgs/accessPageImgs/pss2.png";

import b1 from "../assets/imgs/accessPageImgs/buttom1.png";
import b2 from "../assets/imgs/accessPageImgs/buttom2.png";
import b3 from "../assets/imgs/accessPageImgs/buttom3.png";

import share from "../assets/svgs/share.svg";
import buyme from "../assets/imgs/accessPageImgs/buyme.png";

import colss1 from "../assets/imgs/accessPageImgs/col-ss1.png";
import colss2 from "../assets/imgs/accessPageImgs/col-ss2.png";
import colss3 from "../assets/imgs/accessPageImgs/col-ss3.png";

import col2ss1 from "../assets/imgs/accessPageImgs/col2-ss1.png";
import col2ss2 from "../assets/imgs/accessPageImgs/col2-ss2.png";
import p21 from "../assets/imgs/accessPageImgs/p21.png";



import col2pic1 from "../assets/imgs/accessPageImgs/col2pic1.png";
import col2pic2 from "../assets/imgs/accessPageImgs/col2pic2.png";
import col2pic3 from "../assets/imgs/accessPageImgs/col2pic3.png";
import col2pic4 from "../assets/imgs/accessPageImgs/col2pic4.png";
import col2pic5 from "../assets/imgs/accessPageImgs/col2pic5.png";








// import colss1 from "../assets/imgs/accessPageImgs/col-p1.png";
// import colss2 from "../assets/imgs/accessPageImgs/col-ss2.png";
// import colss3 from "../assets/imgs/accessPageImgs/col-p3.png";

// import col2ss1 from "../assets/imgs/accessPageImgs/col2-p1.png";
// import col2ss2 from "../assets/imgs/accessPageImgs/col2-p2.png";
import ShareModal from "../components/ShareModal";

function AccessPage() {
  const images = [
    {src: ss1 , alt:"pageImg1"},

    
    {src: ss2 , alt:"pageImg2"},
    {src: buyme , alt:"pageImg1", link:"https://buymeacoffee.com/greghalpern"},
    
    // {src: ss3 , alt:"pageImg3"},
    // {src: SS4 , alt:"pageImg4"},
    // {src: ss4 , alt:"pageImg5", link:"https://whatthatmeans.nyc3.cdn.digitaloceanspaces.com/INTRODUCTION%20-%20WHAT%20THAT%20MEANS?"},
    // {src: ss5 , alt:"pageImg6", link:"https://whatthatmeans.nyc3.cdn.digitaloceanspaces.com/EPISODE%201%20-%20TRUMP%20ECONOMY"},
    // {src: ss6 , alt:"pageImg7", link:"https://whatthatmeans.nyc3.cdn.digitaloceanspaces.com/EPISODE%202%20-%20TRILLIONS%20IN%20DEBT"},
    // { src: ss7, alt: "pageImg8", link:"https://whatthatmeans.nyc3.cdn.digitaloceanspaces.com/EPISODE%203%20-%20THE%20BIG%20LIE" },
    // { src: ss8, alt: "pageImg9" },
    { src: ss10, alt: "pageImg9" },
    
    { src: ss15, alt: "pageImg 2", link:"https://whatthatmeans.nyc3.cdn.digitaloceanspaces.com/INSTANT%20HAPPINESS%20MEDITATION" },
    { src: ss16, alt: "pageImg 3", link:"https://whatthatmeans.nyc3.cdn.digitaloceanspaces.com/INSTANT%20HAPPINESS%20MEDITATION" },
    { src: ss17, alt: "pageImg 2", link:"https://whatthatmeans.nyc3.cdn.digitaloceanspaces.com/TOTAL%20CLARITY%20MEDITATION" },
    { src: ss18, alt: "pageImg 3", link:"https://whatthatmeans.nyc3.cdn.digitaloceanspaces.com/TOTAL%20CLARITY%20MEDITATION" },
    { src: ss19, alt: "pageImg 3" }, 

    { src: ss20, alt: "pageImg 3" },

    // { src: download, alt: "pageImg 3" },

    // { src: pss1, alt: "pageImg 3",link:"https://thankyoupresidenttrump.us" },
  ];

  const [isShareVisible, setIsShareVisible] = useState(false);
  const [isEmailModalVisible, setIsEmailModalVisible] = useState(false);
  const handleShareClick = () => {
    setIsShareVisible(true);
  };
  const handleEmailModalClose = () => {
    setIsEmailModalVisible(false);
  };

  const handleClose = () => {
    setIsShareVisible(false);
  };

  return (
    <div className={` ${isEmailModalVisible ? 'backdrop-blur' : ''}`} style={{ backgroundColor: "#0b2866" }}>     
     <div className="grid grid-cols-1 ">
        {/* Images from p1 to p19*/}
        {images.map((image, index) => (
  <div
    key={index}
    className={` md:px-[10%] px-[2.5%] rounded overflow-hidden ${index === 16 ? 'mb-8 ' : ''} `}
  >
    {image.link ? (
      <a href={image.link} target="_blank" rel="noopener noreferrer">
        <img
          src={image.src}
          alt={image.alt}
          className="w-full h-auto object-cover"
        />
      </a>
    ) : (
      <img
        src={image.src}
        alt={image.alt}
        className="w-full h-auto object-cover"
      />
    )}
  </div>
))}

{/* ss20 */}
 

  


{/*  */}


<div className=" px-[4%] ml-1 md:ml-0 md:px-[9%] rounded overflow-hidden w-full">
    
    <img
      src={p21}
      alt="pageImg 20"
      className="w-full h-auto object-cover"
    />
</div> 

        {/* ss12 */}
        <div className="mb-[-4%] grid grid-cols-5 w-[92%] md:w-[82%] ml-[5%] md:ml-[9%] mr-[4%]"> 
  {[
    { src: col2ss1, link: "https://inventorofcrowdfunding.com/", alt: "pageImg 7" },
    { src: col2ss2, link: "https://greghalpernlives.com/", alt: "pageImg 8" },
    { src: colss1, link: "https://channelgreg.com/", alt: "pageImg 4" },
    { src: colss2, link: "https://battletestedwinner.com", alt: "pageImg 5" },
    { src: colss3, link: "https://realalientechnology.com", alt: "pageImg 6" },
  ].map((item, index) => (
    <div
      key={index}
      className="" 
    >
      <a href={item.link} target="_blank" rel="noopener noreferrer" className="">
        <img
          src={item.src}
          alt={item.alt}
          className="w-full h-[80%] " 
        />
      </a>
    </div>
  ))}
</div>

<div className="pb-[-4%] grid grid-cols-5 w-[92%] md:w-[82%] ml-[5%] md:ml-[9%] mr-[4%]"> 
  {[
    { src: col2pic1, link: "https://whatthatmeans.com", alt: "pageImg 7" },
    { src: col2pic2, link: "https://thepeoplesvote.us", alt: "pageImg 8" },
    { src: col2pic3, link: "https://greghalpernvideo.com", alt: "pageImg 4" },
    { src: col2pic4, link: "https://whatthatmeans.net/access", alt: "pageImg 5" },
    { src: col2pic5, link: "https://formula4protocol.teachable.com", alt: "pageImg 6" },
  ].map((item, index) => (
    <div
      key={index}
      className="" 
    >
      <a href={item.link} target="_blank" rel="noopener noreferrer" className="">
        <img
          src={item.src}
          alt={item.alt}
          className="w-full h-[80%] " 
        />
      </a>
    </div>
  ))}
 
</div>

 

  <div className="mt-[-4%]  px-[8%] rounded overflow-hidden w-full">
      <a href="https://whatthatmeans.net/trends" target="_blank" rel="noopener noreferrer">
        <img
          src={b1}
          alt="pageImg 20"
          className="w-full h-auto object-cover"
        />
      </a>
  </div>  
{/*  */}
        <div className="fixed mt-[30%] ml-[70%] md:ml-[75%] ">
          <img
            src={share}
            alt="share icon"
            className=" cursor-pointer w-[80%] md:w-[95%]"
            onClick={handleShareClick}
          />
        </div>
      </div>
      {isShareVisible && <ShareModal onClose={handleClose} />}
    </div>
  );
}

export default AccessPage;
